import config from "../config";
import HttpClient from "../helpers/httpclient";

export const TYPES_INVALID = "TYPES_INVALID";
export const TYPES_FETCHING = "TYPES_FETCHING";
export const TYPES_FETCHED = "TYPES_FETCHED";
export const TYPES_FETCH_FAILED = "TYPES_FETCH_FAILED";

export function fetchTypesOptions(type) {
  const getOption = (t) => ({ value: t.id, label: t.name });
  const getOptions = (types) => ({ options: types.map(getOption) });
  return (_input) => {
    return HttpClient.get(`${config.api}/types/${type}`)
      .then((r) => r.data)
      .then(getOptions);
  };
}
